import { render } from "./detail-target.vue?vue&type=template&id=298dcd1b"
import script from "./detail-target.vue?vue&type=script&lang=js"
export * from "./detail-target.vue?vue&type=script&lang=js"
script.render = render

export default script